import React from "react";
import PropTypes from "prop-types";
import Icon from "../Icon";
import "./ChipContent.scss";

const ChipContent = ({ glyph, label }) => (
    <p className="chip-content">
        <Icon type="FontAwesome" glyph={glyph} />
        {/* eslint-disable-next-line react/no-danger */}
        <small dangerouslySetInnerHTML={{ __html: label }} />
    </p>
);

ChipContent.propTypes = {
    glyph: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
};

export default ChipContent;
